const o=""+new URL("de-logo.png",import.meta.url).href;export{o as _};
//# sourceMappingURL=de-logo-es.js.map
